import React, { useState } from 'react';

const NewRecipeTest = () => {
    const [recipe, setRecipe] = useState({
        name: '',
        image_url: ''
    });

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const blobUrl = URL.createObjectURL(file);
            setRecipe({ ...recipe, image_url: blobUrl });
        }
    };

    return (
        <div style={{ padding: '20px', textAlign: 'center' }}>
            <h2>Prueba de Imagen Local (Blob)</h2>

            <input
                type="file"
                accept="image/*"
                onChange={handleImageChange}
            />

            <div style={{ marginTop: '20px' }}>
                <p>Imagen previsualizada:</p>
                {recipe.image_url && (
                    <img
                        src={recipe.image_url}
                        alt="Preview"
                        style={{ width: '200px', borderRadius: '15px', border: '2px solid #ddd' }}
                    />
                )}
            </div>

            <div style={{ background: '#f4f4f4', padding: '10px', marginTop: '20px' }}>
                <strong>JSON resultante:</strong>
                <pre>{JSON.stringify(recipe, null, 2)}</pre>
            </div>
        </div>
    );
};

export default NewRecipeTest;